import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonToolbar,
  Col,
  Image,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import editImg from '../../images/Provident-Fund/Edit_Fill.svg'
import detailImg from '../../images/Detail.svg'
import { BsPlusLg } from 'react-icons/bs'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { EMP_EJIP_DETAIL } from '../../router/routes'
import ModalCreateFund from '../../components/employees/ejip/modal-create-fund'
import { getEjipFundAPI } from '../../services/ejip'
import Error_false from '../../components/error/error-false'
import Error_500 from '../../components/error/error-500'
import ModalEditFund from '../../components/employees/ejip/modal-edit-fund'
import SpinnerLoading from '../../components/spinner-loading'
import moment from 'moment'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import UseEjipStatus from '../../hooks/use-ejip-status'
import CardCustom from '../../components/custom/card-custom'
import TextNavTitle from '../../components/TextNavTitle'
import Autocomplete from '../../components/custom/autocomplete'
moment.locale('en')

export default function EjipPage() {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [totalRows, setTotalRows] = useState(0)
  const [isModalOpenAddMember, setIsModalOpenAddMember] = useState(false)
  const [isModalOpenEditMember, setIsModalOpenEditMember] = useState(false)
  const [data, setData] = useState([])
  const [dataById, setDataById] = useState()
  const totalLimits = 20
  const [page, setPage] = useState(1)

  const statusEjip = UseEjipStatus()
  useEffect(() => {
    fnGetFirst()
  }, [])
  const fnGetFirst = () => {
    const body = { page: 1, size: totalLimits }
    fnGetData(body)
  }
  const fnGetData = async (body) => {
    try {
      setIsLoading(true)
      const resp = await getEjipFundAPI(body)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setData(resp.result)
        setTotalRows(resp.totalRows)
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }
  const showModalEditMember = (d) => {
    setDataById(d)
    setIsModalOpenEditMember(true)
  }

  const handleCancelEditMember = () => {
    setIsModalOpenEditMember(false)
  }

  const showModalAddMember = () => {
    setIsModalOpenAddMember(true)
  }

  const handleCancelAddMember = () => {
    setIsModalOpenAddMember(false)
  }

  const handleClick = (d) => {
    navigate(
      {
        pathname: EMP_EJIP_DETAIL,
        search: `?${createSearchParams({
          id: d.id,
          name: d.fund_name
        })}`
      },
      { replace: false }
    )
  }

  const [ejipStatus, setEjipStatus] = useState()

  const onSelectStatus = (id) => {
    setPage(1)
    const body = {
      page: 1,
      fundStatusId: id ?? ''
    }
    fnGetData(body)
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>EJIP</TextNavTitle>
      </NavTitle>

      <Col xl={12} className="mb-3">
        <CardCustom
          minHeight=""
          style={{
            height: 'calc(100vh - 70px'
          }}
        >
          <div className="d-flex justify-content-between p-3">
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRows?.toLocaleString()}
            </label>

            <div className="d-flex gap-2">
              <div style={{ minWidth: 180 }}>
                <Autocomplete
                  placeholder="EJIP Status"
                  className="w-100"
                  isClearable={true}
                  value={ejipStatus}
                  options={statusEjip}
                  onChange={(e) => {
                    setEjipStatus(e)
                    onSelectStatus(e?.value)
                  }}
                />
              </div>
              <Button
                size="sm"
                className="border-0 px-4"
                onClick={showModalAddMember}
              >
                <BsPlusLg /> Create New Fund
              </Button>
            </div>
          </div>

          <Table hover responsive>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" pointer-event font-title-table">
                <th className="fw-normal ">#</th>
                <th className="fw-normal ">Fund</th>
                <th className="fw-normal text-center">Fund Opening</th>
                <th className="fw-normal text-center">Fund End Date</th>
                <th className="fw-normal text-center">Closing Date</th>
                <th className="fw-normal text-center">Number of Members</th>
                <th className="fw-normal text-center">Status</th>
                <th className="fw-normal text-center">Edit</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((d, i) => (
                  <tr key={i} className="fw-light font-small-2">
                    <td className="">
                      {page * totalLimits - totalLimits + i + 1}
                    </td>
                    <td className="">{d.fund_name}</td>
                    <td className="text-center fw-light">
                      {moment(d.open_date).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center fw-light">
                      {moment(d.end_date).format('DD/MM/YYYY')}
                    </td>
                    <td className="text-center fw-light">
                      {d.close_date
                        ? moment(d.close_date).format('DD/MM/YYYY')
                        : '-'}
                    </td>
                    <td className="text-center fw-light">{d.num_member}</td>
                    <td
                      className="text-center fw-light"
                      style={{
                        color: d.status_id === 1 ? '#009b47' : '#989898'
                      }}
                    >
                      {d.status}
                    </td>
                    <td className="text-center fw-light">
                      <span className="d-flex justify-content-center">
                        <ButtonToolbar className="d-flex justify-content-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Detail</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => handleClick(d)}
                            >
                              <Image
                                src={detailImg}
                                style={{
                                  width: '20px'
                                }}
                              />
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>

                        <ButtonToolbar className="d-flex justify-content-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-detail">Edit</Tooltip>
                            }
                          >
                            <Button
                              variant="btn btn-outline-primary"
                              className="border-0 d-flex justify-content-center"
                              size="sm"
                              style={{
                                width: '32px',
                                height: '32px'
                              }}
                              onClick={() => showModalEditMember(d)}
                            >
                              <Image src={editImg}></Image>
                            </Button>
                          </OverlayTrigger>
                        </ButtonToolbar>
                      </span>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="mb-0">
                  <td className="text-center" colSpan={13}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(page) => {
                setPage(page)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      <ModalCreateFund
        fnData={fnGetFirst}
        isModalOpenAddMember={isModalOpenAddMember}
        handleCancelAddMember={handleCancelAddMember}
      />
      <ModalEditFund
        dataById={dataById}
        fnData={fnGetFirst}
        statusEjip={statusEjip}
        isModalOpenEditMember={isModalOpenEditMember}
        handleCancelEditMember={handleCancelEditMember}
      />
    </Row>
  )
}
